import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Rightheader from './Rightheader';
import Rightfooter from './Rightfooter';
import './Rightexpress1.css';
import './Rightheader.css';
import './Rightfooter.css';

const RightexpressTracking = () => {

    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<any[]>([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [error, setError] = useState('');

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [shake, setShake] = useState(false);

    const [showPod, setShowPod] = useState(false);
const [zoom, setZoom] = useState(1);
const [isDragging, setIsDragging] = useState(false);
const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    const statusToStep: { [key: string]: number } = {
        Booked: 1,
        InTransit: 2,
        DELIVERED: 3,
        Delivered: 4,
    };

    const togglePod = () => {
        setShowPod(prev => !prev);
    };

   // 🔥 pod image zoom in zoom out function start
const handleWheel = (e: React.WheelEvent<HTMLImageElement>) => {
    e.preventDefault();

    setZoom(prev => {
        const newZoom = prev + (e.deltaY < 0 ? 0.2 : -0.2);
        return Math.min(Math.max(newZoom, 1), 4);
    });
};

const handleMouseDown = () => setIsDragging(true);
const handleMouseUp = () => setIsDragging(false);

const handleMouseMove = (e: React.MouseEvent<HTMLImageElement>) => {
    if (!isDragging) return;

    setPosition(prev => ({
        x: prev.x + e.movementX,
        y: prev.y + e.movementY
    }));
};

const handleDoubleClick = () => {
    if (zoom === 1) {
        setZoom(2);
    } else {
        setZoom(1);
        setPosition({ x: 0, y: 0 });
    }
};


   // 🔥 pod image zoom in zoom out function end


    const fetchData = async () => {

        if (!searchValue.trim()) {
            setError('Please enter a tracking number.');
            setShake(true);
            setTimeout(() => setShake(false), 400);
            return;
        }

        setLoading(true);

        try {

            const docket = searchValue.trim();
            const res = await axios.get(
                // 'https://trackerex.com/TrackingControlerNodeJsApi/MultipleTrackingData',
                'https://trackerex.com/TrackingControlerNodeJsApi/TrackingData',
                {
                    params: {
                        VendorName: 'RIGHTEXPRESS',
                        awbNo: docket,
                        refNo: docket
                    }
                }
            );

            const data = res.data;

            if (data?.status === 1 && Array.isArray(data.data)) {

                // 🔥 SAME IMAGE CHECK LOGIC AS WORKING COMPONENT
                const tryImageExtensions = async (awbNo: string): Promise<string | null> => {
                    const extensions = ['jpg', 'jpeg', 'png'];

                    for (const ext of extensions) {
                        const url = `https://rightexpress.in/Podimage/${awbNo}.${ext}`;
                        const exists = await new Promise<boolean>((resolve) => {
                            const img = new Image();
                            img.src = url;
                            img.onload = () => resolve(true);
                            img.onerror = () => resolve(false);
                        });

                        if (exists) return url;
                    }

                    return null;
                };

                const updatedData = await Promise.all(
                    data.data.map(async (item: any) => {
                        const imageUrl = await tryImageExtensions(item.awbNo);
                        return {
                            ...item,
                            ImageLink: imageUrl,
                        };
                    })
                );

                setTrackingData(updatedData);
                setError('');
                setSearchValue('');
                setShowPod(false);

                setSuccess(true);
                setTimeout(() => setSuccess(false), 1200);

                if (updatedData.length > 0) {
                    const status = updatedData[0].Status;
                    setCurrentStep(statusToStep[status] || 1);
                }

            } else {
                setTrackingData([]);
                Swal.fire({
                    icon: 'warning',
                    title: 'Docket Not Found',
                    text: 'The entered docket number was not found.',
                });
            }

        } catch (error: any) {
            setTrackingData([]);
            setError(
                error.response?.data?.message ||
                'Failed to fetch data. Please check your internet connection.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Rightheader />



            <div className="track-modern-wrapper">


<div className="tracking-info">
  <h2>Track Your Courier</h2>

  <div className="tracking-features">

    {/* Fast Updates */}
    <div className="feature-item">
      <div className="icon-wrapper">
        <svg viewBox="0 0 24 24" className="feature-icon">
          <path
            d="M3 12L12 4L21 12M5 10V20H19V10"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <span>Fast Updates</span>
    </div>

    {/* Secure Tracking */}
    <div className="feature-item">
      <div className="icon-wrapper">
        <svg viewBox="0 0 24 24" className="feature-icon">
          <path
            d="M6 10V6C6 4 8 2 12 2C16 2 18 4 18 6V10M5 10H19V22H5V10Z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <span>Secure Tracking</span>
    </div>

    {/* Live Shipment Status */}
    <div className="feature-item">
      <div className="icon-wrapper">
        <svg viewBox="0 0 24 24" className="feature-icon">
          <path
            d="M3 7H15V17H3V7Z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M15 10H19L21 13V17H15V10Z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
          <circle cx="7.5" cy="18.5" r="1.5" fill="currentColor" />
          <circle cx="17.5" cy="18.5" r="1.5" fill="currentColor" />
        </svg>
      </div>
      <span>Live Shipment Status</span>
    </div>

  </div>
</div>



                {/* ================= SEARCH BOX ================= */}
                <div className="track-modern-card">

                    <form
                        className={`track-input-group ${shake ? "shake" : ""}`}
                        onSubmit={(e) => {
                            e.preventDefault();
                            fetchData();
                        }}
                    >

                        {/* Existing icon untouched */}
                        <span className="track-modern-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M3 7L12 2L21 7V17L12 22L3 17V7Z"
                                    stroke="#a2a2a0"
                                    strokeWidth="2"
                                    strokeLinejoin="round" />
                                <path d="M3 7L12 12L21 7"
                                    stroke="#6a6a6a"
                                    strokeWidth="2"
                                    strokeLinejoin="round" />
                            </svg>
                        </span>

                        {/* Floating wrapper added */}
                        <div className="floating-wrapper">

                            <input
                                type="text"
                                className="track-modern-input"
                                value={searchValue}
                                onChange={handleInputChange}
                                required
                            />

                            <label className={searchValue ? "active" : ""}>
                                Enter Tracking Number
                            </label>

                        </div>

                        <button
                            type="submit"
                            className={`track-modern-btn ${success ? "success" : ""}`}
                        >

                            {loading ? (
                                <span className="spinner"></span>
                            ) : success ? (
                                <span className="checkmark">✓</span>
                            ) : (
                                <>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginRight: "6px" }}>
                                        <circle cx="11" cy="11" r="7"
                                            stroke="white"
                                            strokeWidth="2" />
                                        <line x1="16.65" y1="16.65"
                                            x2="21" y2="21"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round" />
                                    </svg>
                                    Track
                                </>
                            )}

                        </button>

                    </form>

                    {error && <div className="track-modern-error">{error}</div>}

                </div>

                {/* ================= RESULTS (UNCHANGED) ================= */}
              

            {trackingData.length > 0 && (

  <div className="tracking-full-wrapper">

    {/* ================= MAIN DETAILS ================= */}
    <div className="tracking-details-card">

      <h4 className="tracking-title">Tracking Details</h4>

      <table className="tracking-table">
        <thead>
          <tr>
            <th>AwbNo</th>
            <th>Ref_No</th>
            <th>BookDate</th>
            <th>Consignee_Name</th>
            <th>Status</th>
            {/* <th>ManifestNo</th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{trackingData[0].awbNo}</td>
            <td>{trackingData[0].refNo || '-'}</td>
            <td>{trackingData[0].bookDate}</td>
            <td>{trackingData[0].consigneeName}</td>
            <td>{trackingData[0].Status}</td>
            {/* <td>{trackingData[0].Manifest_No}</td> */}
          </tr>
        </tbody>

        <thead>
          <tr>
            <th>Qty</th>
            <th>Origin</th>
            <th>Destination</th>
            <th>Receiver Name</th>
            <th>Delivery Date</th>
            {/* <th>Vehicle_No</th> */}
            {/* <th>Expt Date Delivery</th> */}
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{trackingData[0].Qty}</td>
            <td>{trackingData[0].origin}</td>
            <td>{trackingData[0].destinationName}</td>
            <td>{trackingData[0].recvName}</td>
            <td>{trackingData[0].delvDt}</td>
            {/* <td>{trackingData[0].Vehicle_No}</td> */}
            {/* <td>{trackingData[0].ExptDateOfDelvDt}</td> */}
          </tr>
        </tbody>
      </table>

      {/* ================= PROGRESS BAR ================= */}

 <div className="shipment-progress">

  <div className="shipment-line">
    <div
      className="shipment-line-active"
      style={{
        width:
          currentStep === 1
            ? "0%"
            : currentStep === 2
            ? "33%"
            : currentStep === 3
            ? "66%"
            : "100%",
      }}
    ></div>
  </div>

  <div className="shipment-steps">

    {/* BOOKED */}
    <div className={`shipment-step ${currentStep >= 1 ? "active" : ""}`}>
      <div className="shipment-icon">
        <svg viewBox="0 0 24 24">
          <path d="M3 7L12 2L21 7V17L12 22L3 17V7Z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"/>
          <path d="M3 7L12 12L21 7"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"/>
        </svg>
      </div>
      <span>BOOKED</span>
    </div>

    {/* IN TRANSIT */}
    <div className={`shipment-step ${currentStep >= 2 ? "active" : ""}`}>
      <div className="shipment-icon">
        <svg viewBox="0 0 24 24">
          <path d="M3 13H15V6H3V13Z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"/>
          <path d="M15 9H19L21 12V13H15"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"/>
          <circle cx="7" cy="17" r="2"/>
          <circle cx="17" cy="17" r="2"/>
        </svg>
      </div>
      <span>IN-TRANSIT</span>
    </div>

    {/* OUT FOR DELIVERY */}
    <div className={`shipment-step ${currentStep >= 3 ? "active" : ""}`}>
      <div className="shipment-icon">
        <svg viewBox="0 0 24 24">
          <path d="M12 2C8 2 5 5 5 9C5 14 12 22 12 22C12 22 19 14 19 9C19 5 16 2 12 2Z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"/>
          <circle cx="12" cy="9" r="2"/>
        </svg>
      </div>
      <span>OUT FOR DELIVERY</span>
    </div>

    {/* DELIVERED */}
    <div className={`shipment-step ${currentStep >= 4 ? "active" : ""}`}>
      <div className="shipment-icon">
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"/>
          <path d="M8 12L11 15L16 9"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"/>
        </svg>
      </div>
      <span>DELIVERED</span>
    </div>

 {/* ================= POD SECTION (FIXED) ================= */}
                         {trackingData[0].Status?.toLowerCase() === "delivered" && (

                                <div className="tracking-pod-card">

                                    {/* <h4>Proof Of Delivery</h4> */}

                                    {/* <button
                                        onClick={togglePod}
                                        className="pod-view-btn"
                                    >
                                        {showPod ? "Hide POD" : "View POD"}
                                    </button> */}

{/* View Button */}
<button
    onClick={() => setShowPod(true)}
    className="pod-view-btn"
>
    View POD
</button>

{/* Modal */}
{showPod && (
    <div className="pod-modal-overlay">

        <div className="pod-modal">

            {/* Close Button */}
            <button
                className="pod-close-btn"
               onClick={() => {
    setShowPod(false);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
}}

            >
                ×
            </button>

            {/* Image */}
          <img
    src={trackingData[0].podImg || trackingData[0].ImageLink}
    alt="POD"
    className="pod-modal-image"
    style={{
        transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
        cursor: isDragging ? "grabbing" : "grab"
    }}
    onWheel={handleWheel}
    onMouseDown={handleMouseDown}
    onMouseUp={handleMouseUp}
    onMouseMove={handleMouseMove}
    onDoubleClick={handleDoubleClick}
/>


            <a
                href={trackingData[0].podImg || trackingData[0].ImageLink}
                download
                className="pod-download-btn mt-3"
            >
                Download POD
            </a>

        </div>

    </div>
)}


                                </div>
                            )}

  </div>

</div>


    </div>


    {/* ================= STATUS HISTORY ================= */}

    <div className="tracking-history-card">

      <h4>Status Tracking</h4>

      <table className="tracking-table">
        <thead>
          <tr>
            <th>AwbNo</th>
            <th>Status_Date</th>
            <th>Status_Time</th>
            <th>Location_Update</th>
            <th>Activity</th>
          </tr>
        </thead>

        <tbody>
          {trackingData[0].podHistory?.map((history: any, idx: number) => (
            <tr key={idx}>
              <td>{trackingData[0].awbNo}</td>
              <td>{history.DelvDt}</td>
              <td>{history.DelvTime}</td>
              <td>{history.destinationName}</td>
              <td>{history.Remark}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>

  </div>

)}

</div>

            <Rightfooter />
        </>
    );
};

export default RightexpressTracking;
